/* ============================================================
   NUTRIZONE — Microinteracciones
   Mejora progresiva: sin JS la página funciona igual.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header: sombra sutil al separarse del top */
  var header = document.querySelector('header');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('stuck', window.scrollY > 8);
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Reveal on scroll */
  if (!reduce && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll(
      '.sec-head, .duo-card, .review, .pk, .stat, .nutri, table, .warn, .deficit-img, .sg-visual'
    );
    if (targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, i) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = Math.min(i * 60, 240);
          setTimeout(function () { el.classList.add('in'); }, delay);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      targets.forEach(function (el) {
        el.classList.add('reveal');
        io.observe(el);
      });
    }
  }
})();
